export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_02-09cf6b8d9c08f4bfad29aa47329ac54d.png";